import grapesjs from 'grapesjs';
import loadBlocks from './blocks';
import loadComponents from './components';

export default grapesjs.plugins.add('gjs-animated-hamburger-button', (editor, opts = {}) => {
  const config = {
    blocks: [
      'hamburgerbutton',
    ],
    name: 'animatedhamburgerbutton',
    stylePrefix: 'gjs-',
    labelHamburgerButton: 'Botón Hamburguesa con Menu',
    category: 'Botones',
    ...opts,
  };
  // eslint-disable-next-line no-restricted-syntax
  for (const name in config) {
    if (!(name in opts)) opts[name] = config[name];
  }
  loadBlocks(editor, config);
  loadComponents(editor, opts);
});
